class PriceCalculator {
    constructor() {
        this.configurators = {};
        this.finalPrices = [];
        this.init();
        
        this.debouncedCalculate = _.debounce(this.calculate.bind(this), 250);
    }

    init() {
        this.setupConfigurators();
        this.bindEvents();
    }

    setupConfigurators() {
        $('.pc-configurator-popup').each((_, configurator) => {
            const $configurator = $(configurator);
            const configuratorId = $configurator.data('configurator-id');
            
            if (configuratorId) {
                this.configurators[configuratorId] = {
                    dynamic_variables: window['pcConfiguratorDynamicVariables' + configuratorId]['dynamic_variables'] || {},
                    formulas: window['pcConfiguratorDynamicVariables' + configuratorId]['formula_builder']['formulas'] || {},
                    result_formula: window['pcConfiguratorDynamicVariables' + configuratorId]['formula_builder']['result_formula'] || '',
                    static_variables: window['pcConfiguratorDynamicVariables' + configuratorId]['static_variables'] || {},
                    qtys: window['pcConfiguratorDynamicVariables' + configuratorId]['qtys'] || [],
                    $element: $configurator
                };

                this.initializeVariables(configuratorId);
                this.calculate(configuratorId);
            }
        });

    }

    initializeVariables(configuratorId) {
        const configurator = this.configurators[configuratorId];
        if (!configurator) return;

        console.log(configurator.dynamic_variables, ' CONFIGURATOR');

        configurator.$element.find('.pc-option').each((_, option) => {

            const $option = $(option);

            $(option).find('.pc-option-value.active').each((_, value) => {
                if($(value).attr('data-value') !== undefined || $(this).attr('data-value') !== null) {
                    configurator.dynamic_variables[$(value).data('option-slug')] = $(value).attr('data-value');
                }
            });

        });  

        console.log(configurator.dynamic_variables, ' AFTER CONFIGURATOR');

    }

    bindEvents() {
        $(document).on('option-changed gallery-option-changed size-option-changed', (_, value) => {
            const $option = $(value.element);
            const $configurator = $option.closest('.pc-configurator-popup');
            const configuratorId = $configurator.data('configurator-id');
            
            if (configuratorId) {
                this.configurators[configuratorId].dynamic_variables[value.optionSlug] = parseFloat(value.value.toString().replace(',', '.'));
                this.debouncedCalculate(configuratorId);
            }

        });

        $('body').on('change input blur paste', '.pc-quantity-input', (e) => {
            const $input = $(e.target);
            const $configurator = $input.closest('.pc-configurator-popup');
            const configuratorId = $configurator.data('configurator-id');

            if (configuratorId) {
                this.calculate(configuratorId);
            }
        });

    }

    calculate(configuratorId) {
        const configurator = this.configurators[configuratorId];
        if (!configurator) return;

        try {
            const formulas = configurator.formulas;
            const result_formula = configurator.result_formula;
            if (!result_formula) return;

            let allVariables = {};
            let finalPrices = [];

            let qtys = configurator.qtys;
            let baseQty = configurator.$element.find('.pc-quantity-input').val();
            baseQty = parseInt(baseQty) || 1;

            if (!qtys.includes(baseQty)) {
                qtys.push(baseQty);
            }

            console.log(configurator.dynamic_variables, ' DYNAMIC VARIABLES');

            qtys.forEach(qty => {
                allVariables = { ...configurator.dynamic_variables, ...configurator.static_variables };
                allVariables['qty'] = qty;
                const results = this.calculateFormulas(formulas, allVariables);
                allVariables = { ...allVariables, ...results };
                const finalPrice = this.calculateFormulas([result_formula], allVariables);
                this.finalPrices[qty] = finalPrice[0];
            });

            this.setupQtyPrices(configuratorId);
            this.setupFinalPrice(configuratorId);
            
        } catch (error) {
        }
    }

    setupFinalPrice(configuratorId) {
        const configurator = this.configurators[configuratorId];
        if (!configurator) return;

        const qtys = configurator.qtys.sort((a, b) => a - b);
        // let baseQty = configurator.selected_qty;
        let baseQty = configurator.$element.find('.pc-quantity-input').val();
        baseQty = parseInt(baseQty) || 1;

        if (!qtys.includes(baseQty)) {
            baseQty = qtys[0];
        
            for (let qty of qtys) {
                if (qty <= baseQty) {
                    baseQty = qty;
                } else {
                    break;
                }
            }
        }

        const basePrice = this.finalPrices[baseQty];
        const pricePerOne = basePrice / baseQty;
        const totalPrice = pricePerOne * baseQty;

        configurator.$element.find('.pc-cart-button')
            .attr('data-price', parseFloat(totalPrice).toFixed(2))
            .attr('data-price-per-one', parseFloat(pricePerOne))
            .attr('data-qty', baseQty);

        configurator.$element.find('.pc-custom-quantity-row .pc-price-cell .price').text(parseFloat(totalPrice).toFixed(2));

        // Обновляем активную строку в таблице
        configurator.$element.find(`.pc-quantity-table .active`).removeClass('active');
        if (qtys.includes(baseQty)) {
            configurator.$element.find(`.pc-quantity-table [data-qty="${baseQty}"]`).addClass('active');
        }
    }   

    setupQtyPrices(configuratorId) {
        const configurator = this.configurators[configuratorId];
        if (!configurator) return;
        let $table = configurator.$element.find('.pc-quantity-table');

        this.finalPrices.forEach((price, qty) => {
            $table.find(`[data-qty="${qty}"]`).data('price', price);
            $table.find(`[data-qty="${qty}"]`).find('.pc-price-cell .price').text(parseFloat(price).toFixed(2));
        });
    }

    replaceVariablesInFormula(formula, variables) {
        let replacedFormula = formula;

        // Заменяем все {имя_переменной} на их значения
        for (const [key, value] of Object.entries(variables)) {
            const regex = new RegExp(`\\b${key}\\b`, "g");
            replacedFormula = replacedFormula.replace(regex, value);
        }

        return replacedFormula;
    }

    calculateFormulas(formulas, allVariables) {
        let results = {};
        let unresolved = { ...formulas };
        let iterations = 0;
        const maxIterations = 100;

        while (Object.keys(unresolved).length > 0) {
            let unresolvedKeys = Object.keys(unresolved);
            let resolvedInThisIteration = false;
            iterations++;

            if (iterations > maxIterations) {
                console.warn('Превышено максимальное количество итераций в расчете формул');
                break;
            }

            for (const key of unresolvedKeys) {
                const formula = unresolved[key];

                try {
                    const preparedFormula = this.replaceVariablesInFormula(formula, allVariables);
                    const result = math.evaluate(preparedFormula);

                    if (typeof result === 'number' && !isNaN(result)) {
                        results[key] = result;
                        allVariables[key] = result;
                        delete unresolved[key];
                        resolvedInThisIteration = true;
                    }
                } catch (e) {
                    continue;
                }
            }

            // Если за итерацию ничего не удалось вычислить - прерываем цикл
            if (!resolvedInThisIteration) {
                console.warn('Не удалось разрешить формулы в этой итерации');
                break;
            }
        }

        // Если остались неразрешенные формулы, записываем их как 0
        for (const key of Object.keys(unresolved)) {
            console.log(key, ' KEY');
            console.log(unresolved, ' UNRESOLVED');
            results[key] = 0;
            allVariables[key] = 0;
            console.warn(`Формула для ${key} не может быть вычислена и установлена в 0`);
        }

        return results;
    }

    updatePriceDisplay(configuratorId, price) {
        const configurator = this.configurators[configuratorId];
        if (!configurator) return;

        configurator.$element.find('.pc-configurator-price').text(price.toFixed(2));
    }
}

/* window.productConfigurator = window.productConfigurator || {};
window.productConfigurator.priceCalculator = new PriceCalculator();  */